import Avatar from '@/components/ui/avatar';
import { cn } from '@/utils/cn';
import { format } from 'date-fns';
import LoadingSpinner2 from '@/components/ui/new-loading-spinner';
import useTicketActivityTab from './use-ticket-activity-tab';
import EmptySection from '@/components/ui/_r/empty/empty-section';
import { TypographyWithMention } from '@/components/ui/_refactor/data-display/typography-with-mention';

interface ITicketActivityTabProps {
  ticketId: string;
  limit?: number;
}
const TicketActivityTab = ({ ticketId, limit = 10 }: ITicketActivityTabProps) => {
  const { listTicketActivity, hasNextPage, fetchNextPage, isFetchingNextPage, isLoading, isError, isEmpty } =
    useTicketActivityTab({ ticketId, limit });

  return (
    <div className="flex flex-col gap-[12px] h-full">
      <div className="flex flex-col  h-full ">
        {isLoading ? (
          <div className="flex items-center justify-center w-full h-full ">
            <LoadingSpinner2 className="w-[26px] h-[26px]" />
          </div>
        ) : isError ? (
          <div className="text-center py-4">
            <p className="text-[12px] text-[#9D9D9C]">Error fetching activity</p>
          </div>
        ) : isEmpty ? (
          <EmptySection
            type="data"
            title="Activity will appear here"
            description="When make any update to ticket will show here."
          />
        ) : (
          <>
            {listTicketActivity.map((ticketActivity, index) => {
              return (
                <div
                  key={ticketActivity.spaceLogId}
                  className={cn(
                    'flex gap-[8px] items-start px-[16px] min-w-0 py-[10px] border-b-[1px] border-[#D9D9D9]'
                  )}
                >
                  <Avatar
                    imgSrc={ticketActivity.user.profileImage || ''}
                    username={ticketActivity.user.fullname || ''}
                    className="w-[22px] h-[22px] shrink-0"
                  />
                  <div className="flex flex-col min-w-0 overflow-x-hidden flex-1">
                    <span className="text-[#25151E] text-[12px] font-[700] break-words">
                      {ticketActivity.user.fullname}
                    </span>
                    <span className="text-[#25151E] text-[12px] font-[400] break-words">
                      <TypographyWithMention content={ticketActivity.activityDetail} />
                    </span>
                    <span className="text-[#9D9D9C] text-[8px] font-[400] break-words">
                      {ticketActivity?.createdAt ? format(ticketActivity?.createdAt, 'dd MMM yyyy, HH:mm') : '-'}
                    </span>
                  </div>
                </div>
              );
            })}
            {hasNextPage && (
              <div className="flex items-center justify-center py-[8px]">
                <button
                  className="text-[12px] text-[#1F445A] font-semibold cursor-pointer disabled:opacity-50"
                  onClick={() => fetchNextPage()}
                  disabled={isFetchingNextPage}
                >
                  {isFetchingNextPage ? 'Loading...' : 'See more'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TicketActivityTab;
